// extracted by mini-css-extract-plugin
export default {"text-button":"x8n90YBJL7_IIclATBlL"};